import React, { useEffect } from "react";
import { connect } from "react-redux";
import { alertActions, orgActions } from "../../actions";
import { Link } from "react-router-dom";
import { history } from "../../helpers";
import ReactTooltip from "react-tooltip";

function OrgList(props) {
  const { authentication, org, getOrgList, success } = props;
  const orgList = org?.list;


  const location = history.location;
  const message = location.state?.message;
  useEffect(() => {
    getOrgList();

  }, [])

  useEffect(() => {
    if (message) {
      success(message);
    }
  }, [message])

  const addicon = require("../../images/add.png").default;


  const nestOrgList = (orgList) => {
    let tmpList = JSON.parse(JSON.stringify(orgList));
    let outMap = new Map();
    let outList = [];

    for (const org of tmpList) {
      if ((org.org_id === authentication.user.org_id) ||
        (authentication.user.org_id === 1 && org.parent_org_id === authentication.user.org_id)) {
        org.children = [];
        outMap.set(org.org_id, org);
      }
    }

    for (const org of tmpList) {
      if (org.parent_org_id > 1) {
        if (outMap.get(org.parent_org_id))
          outMap.get(org.parent_org_id).children.push(org);
      }
    }

    for (const [org_id, org] of outMap.entries()) {
      outList.push(org);
    }

    return outList.length === 0 ? orgList : outList;
  }


  const headers = ["Display Name", "Type", "User Count"];
  const tableHeaders = headers.map((header, i) => <th key={i}>{header}</th>);

  const outList = nestOrgList(orgList);

  const tableRows = !outList
    ? null
    : outList.map((org, i) => (
      <>
        <tr key={i + '-' + org.org_id}>
          <td><b>
            <Link
              to={{
                pathname: "/org/" + org.org_id,
                state: { org_to_edit: org },
              }}
            >
              {org.display_name}
            </Link>
          </b></td>
          <td>{org.org_type === "Dealer Group" ? <b>Dealer Group</b> : org.org_type}</td>
          <td>
            <Link
              to={{
                pathname: "/org/" + org.org_id + "/users",
                state: {},
              }}
            >
              {org.user_count}
            </Link>
          </td>

        </tr>
        {org.children && (

          org.children.map((org, i) => (

            <tr key={i + '-' + org.org_id}>
              <td>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Link
                  to={{
                    pathname: "/org/" + org.org_id,
                    state: { org_to_edit: org },
                  }}
                >
                  {org.display_name}
                </Link>
              </td>
              <td>{org.org_type}</td>
              <td>
                <Link
                  to={{
                    pathname: "/org/" + org.org_id + "/users",
                    state: {},
                  }}
                >
                  {org.user_count}
                </Link>
              </td>
            </tr>

          ))
        )

        }

      </>
    ));



  return (
    <div>
      <div className="searchMain">
        <div>
          <h3>
            Orgs
            &nbsp;&nbsp;&nbsp;
            {authentication.user.org_id === 1 && (
              <>
                <div className="editJacketNameIcon" data-tip data-for="edit org">
                  <Link
                    to={{
                      pathname: "/org/add",
                    }}
                  >
                    <img src={addicon} width="20px" alt="add" />
                  </Link>
                </div>
                <ReactTooltip id="edit org" place="bottom" effect="solid" data-type="info" delayShow={300}>
                  create new org
                </ReactTooltip>
              </>
            )}




          </h3>
        </div>
        <br />
        <table className="paleBlueRows narrow">
          <thead>
            <tr>
              {tableHeaders}
            </tr>
          </thead>
          <tbody>
            {tableRows}
          </tbody>
        </table>
      </div>
      <div className="pageFooterBuffer">
        &nbsp;
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const actionCreators = {
  createOrg: orgActions.createOrg,
  getOrgTypes: orgActions.getOrgTypes,
  getOrgList: orgActions.getList,
  success: alertActions.success
};

const connectedOrgList = connect(mapStateToProps, actionCreators)(OrgList);
export { connectedOrgList as OrgList };
